import React from "react";
import Sidebar from "../../../components/sidebar/index";
import NavigationBar from "../../../components/navigationbar/index";
import { Container } from "react-bootstrap";
import "../../../styles/theme.scss";
// import Sidebar from './navbar/Sidebar';
// import NavbarTop from "./navbar/NavbarTop";

export default function DashboardLayout({ children, titles }) {
  // const [showMenu, setShowMenu] = useState(true);

  // const ToggleMenu = () => {
  //   return setShowMenu(!showMenu);
  // };

  // console.log("TITLE ::::::::DashboardLayout ", titles);


  return (
    <div className="h-100 position-relative main-content">
      {/* <Sidebar className="position-fixed start-0 top-0 bottom-0" /> */}
      <Sidebar className="position-fixed start-0 top-0 bottom-0" />

      <div className="position-relative pg-content">
        <Container className="px-4 mx-auto pg-container">
          <NavigationBar titles={titles}/>
          <main className="pg-mian-content">{children}</main>
        </Container>
      </div>
    </div>
  );
}
